// eslint-disable-next-line no-unused-vars
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import schemaModule from '../modules/schema';
import intlModule from '../modules/intl';
import { getLogger } from '../logger';

import useMeta from './useMeta';
import { createEntityValidator } from './utils';

const logger = getLogger('meta-form');

export function MetaForm({ metaId, source, language, children, onChange, onErrorChange, ...props }) {
  if (typeof children !== 'function') {
    throw new Error('Child must be a function.');
  }
  const messages = useSelector(intlModule.selectors.getMessages);
  const schemaDescriptors = useSelector(schemaModule.selectors.getSchemaDescriptors);

  const [errors, setErrors] = useState();

  const [
    editableSource,
    getProperty,
    setProperty,
    getTranslatableProperty,
    setTranslatableProperty,
    isLoading,
    meta,
  ] = useMeta(source, metaId, {
    lang: language,
  });

  const errorHandler = useCallback(
    err => {
      if (err) {
        setErrors(err);
        onErrorChange(err);
      } else {
        setErrors(undefined);
        onErrorChange(undefined);
      }
    },
    [setErrors, editableSource]
  );

  const validate = useCallback(
    createEntityValidator(metaId, editableSource, schemaDescriptors, messages, errorHandler),
    [metaId, editableSource, schemaDescriptors, messages, errorHandler]
  );

  useEffect(() => {
    if (source != null) {
      logger.trace('HasChanges', source, editableSource);
      validate();
      onChange(editableSource);
    }
  }, [editableSource]);

  const context = {
    source: editableSource,
    errors,
    isMetaLoading: isLoading,
    isLoading,
    getProperty,
    setProperty,
    getTranslatableProperty,
    setTranslatableProperty,
    meta: meta,
    validate,
    transfer: {
      ...props,
    },
  };
  return children(context);
}
MetaForm.defaultProps = {
  source: {},
  language: 'en',
  onChange: () => {},
  onErrorChange: () => {},
};
MetaForm.propTypes = {
  metaId: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  source: PropTypes.object,
  language: PropTypes.string,
  onChange: PropTypes.func,
  onErrorChange: PropTypes.func,
};

export default MetaForm;
